import * as React from 'react';

export interface BaseButtonProps {
  variant?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  automationID?: string;
}

interface VariantProps {
  [key: string]: string;
}

const variantStyles: VariantProps = {
  secondary: 'bg-white border border-[#B9B9B9] color-fontBlock',
  tertiary: 'bg-navy border-transparent text-white',
  disabled: 'bg-[#F3F3F3] border border-white text-[#898989] cursor-auto pointer-events-none',
  plain: 'bg-white px-1 py-0',
  plainDisabled: 'bg-white px-1 py-0 opacity-25',
  default: 'text-white bg-[#009965] border border-[#009965] cursor-pointer'
};

const BaseButton: React.FC<BaseButtonProps> = ({ children, variant, onClick, automationID }) => {
  return (
    <button
      id={automationID}
      className={`first:mr-3 rounded font-nunitoBold text-sm leading-[21px] px-6 py-2 focus:outline-none ${
        (variant && variantStyles[variant]) || variantStyles.default
      }`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default BaseButton;
